import { render, staticRenderFns } from "./dingInfo.vue?vue&type=template&id=4fa4de66"
import script from "./dingInfo.vue?vue&type=script&lang=js"
export * from "./dingInfo.vue?vue&type=script&lang=js"
import style0 from "./dingInfo.vue?vue&type=style&index=0&id=4fa4de66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports